var _style, _path, _path2, _path3, _path4, _path5, _polygon, _polygon2, _polygon3, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeritage01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:2.8552;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:1.0826;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;stroke:#000000;stroke-width:0.999;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.1,111.7c1,0.7,1,3.2,1.1,6.9c0.1,3.4-0.3,5.9-0.4,6.3c-2.2,13.5-0.6,37.5-2.9,65 c-0.2,2.4-0.7,7.8,2.1,13.6c2,4.2,4.8,6.9,6.6,8.4c-3.4,1.8-9.1,4.2-15.1,2.8c-20.6-4.8-34.7-51.3-18.9-79.9 C295.7,120.1,312.1,109.5,315.1,111.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107,111.7c-1,0.7-1,3.2-1.1,6.9c-0.1,3.4,0.3,5.9,0.4,6.3c2.2,13.5,0.6,37.5,2.9,65c0.2,2.4,0.7,7.8-2.1,13.6 c-2,4.2-4.8,6.9-6.6,8.4c3.4,1.8,9.1,4.2,15.1,2.8c20.6-4.8,34.7-51.3,18.9-79.9C126.4,120.1,110,109.5,107,111.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224.9,447.2H211c-4.4,0-9.2-0.1-14.4-0.2c-9.7-0.2-20.9-0.7-33.6-1.7c-16.9-1.4-30.9-2.6-49.3-7.1 c-7.9-2-14.3-3.9-18.8-5.4c0.2-1.8,0.5-4.4,0.9-7.6c3.7-31.7,6.1-46,7.8-60.1c2.9-23.7,3.2-42,3.5-56.7c0.3-16.2,0.5-34.6-1.9-58.6 c-1.6-15.3-3.7-28.2-5.6-37.8c0,0,0-0.1,0-0.1c-0.1-0.6-0.2-1.2-0.4-1.9c1.2-0.5,2.8-1.3,4.5-2.5c1.4-1,2.9-2.2,4.3-3.8 c0.2-0.3,1.8-2,3.2-4.4c4.6-7.7,5-18.7,5.1-20.9c0.4-12.6,0.6-18.9-0.5-27.9c-1.2-9.9-3.6-23.4-8.8-39.2c-0.2-0.6-0.4-1.3-0.7-1.9 c14-5.4,28-10.8,42-16.1c5.5-2.1,11-4.2,16.6-6.4c-0.1,3.9-0.1,7.9,0,12.2c0.6,24.1,4.7,54.5,17.5,87c6.2,15.7,16.4,41.7,28.7,57.8 c4.1,5.4,8.4,9.7,12.9,12.1c0.3,54.1,0.6,108.2,0.9,162.3C224.8,420.7,224.9,445,224.9,447.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.7,97.9c-0.5,24.4-4.4,55.6-17.5,89.1c-6.1,15.5-16.1,40.9-28.2,57.1c-12.3-16.2-22.5-42.1-28.7-57.8 c-12.8-32.5-16.9-62.9-17.5-87c13.9,4,28.6,6.2,43.8,6.2C225.4,105.4,241.5,102.8,256.7,97.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.6,433.5c-4.5,1.5-10.9,3.4-18.8,5.4c-18.4,4.5-32.4,5.7-49.3,7.1c-19.6,1.6-35.4,1.8-48,1.9h-13.9V447 c0-5,0.1-25.8,0.1-27.8c0.3-54.1,0.6-108.2,0.9-162.3c4.7-2.6,9.2-7.1,13.4-12.9c12.1-16.2,22.1-41.6,28.2-57.1 c13.2-33.5,17.1-64.7,17.5-89.1c0.1-3.6,0.1-7,0-10.2c4.5,1.7,9,3.5,13.4,5.2c15,5.8,30,11.6,45.1,17.4c-0.1,0.4-0.3,0.8-0.4,1.2 c-5.4,16.1-7.8,29.8-9.1,39.9c-1.1,9-0.9,15.3-0.5,27.9c0.1,2.2,0.5,13.2,5.1,20.9c1.4,2.4,3,4.1,3.2,4.4c2.3,2.5,4.8,4.2,6.8,5.2 c0.7,0.4,1.4,0.7,2,1c0,0.3-0.1,0.5-0.2,0.8c0,0.2-0.1,0.5-0.1,0.7c-1.9,9.7-4.1,22.7-5.7,38.3c-2.4,24-2.2,42.4-1.9,58.6 c0.3,14.7,0.6,33,3.5,56.7c1.7,14.1,4.1,28.4,7.8,60.1C326.1,429.1,326.4,431.7,326.6,433.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "239.8,333.3 299.3,330.6 299.3,335.5 239.8,338.3 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "180.9,334.9 121.4,332.2 121.4,337.1 180.9,339.8 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "290.1,191.8 249.7,191.8 252.8,181 293,181 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 206.2,
    cy: 261.3,
    r: 4.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.2,
    cy: 297.2,
    r: 4.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.2,
    cy: 340.6,
    r: 4.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeritage01);
export default __webpack_public_path__ + "static/media/Heritage-01.5aa21cf2474514fc0466b1fcaa9f8316.svg";
export { ForwardRef as ReactComponent };